import { useBreakpointValue } from '@chakra-ui/react';

const useIsMobile = () => useBreakpointValue({ base: true, lg: false }) ?? true;

export default useIsMobile;
